(function(angular, _) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('WtReportAnalysisLive', ['WtReportAnalysis', '$injector', function(WtReportAnalysis, $injector) {
            const TimesDynamic = $injector.get('TimesDynamic');

            /**
             * @ngdoc service
             * @name WtReportAnalysisLive
             * @description Report live analysis constructor for analyses added as report elements
             */
            return class WtReportAnalysisLive extends WtReportAnalysis {
                constructor() {
                    super(...arguments);

                    // Adds older browsers support (IE < 11)
                    this.constructor = this.constructor || WtReportAnalysisLive;
                }

                /**
                 * @ngdoc method
                 * @name WtReportAnalysisLive#getLivePeriodTitle
                 * @description Gets the dynamic time range title that corresponds to the predefined time filter of a live kpi
                 * @returns {string}
                 */
                getLivePeriodTitle() {
                    const timeFilter = this.getOwnTimeFilter();
                    const dynamicTimeFilter = TimesDynamic.getDynamicTimeRangeByKey(_.get(timeFilter, 'value1'));
                    return _.get(dynamicTimeFilter, 'title', '');
                }

                /**
                 * @ngdoc method
                 * @name WtReportAnalysisLive#setLivePeriod
                 * @description Sets the dynamic time range id that is used in the predefined time filter of a live kpi
                 * @param {string} timePeriod The time period
                 * @returns {WtReportAnalysisLive}
                 */
                setLivePeriod(timePeriod) {
                    _.set(this.getOwnTimeFilter(), 'value1', timePeriod);

                    if (this.timeFilter_) {
                        _.set(this.timeFilter_, 'value1', timePeriod);
                    }

                    return this;
                }
            };
        }]);
})(window.angular, window._);
